import { AxiosInstance } from "axios";
import { RateDependenciesModel } from "models/dependencies/Rate";

export const getAll =
  (axios: AxiosInstance) => async (): Promise<RateDependenciesModel> => {
    return await axios
      .get("settings/dependencies/rate")
      .then(({ data }) => data);
  };
